export default {"src":"/_next/static/media/Checked .ed934eae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};